// Pixel sprites for loot collectibles. Mirrors stamp-icons.tsx. An icon that
// is an https URL is shop-uploaded art (Cloudinary pixel pipeline).

const MAPS: Record<string, string[]> = {
  chipped_mug:      ['........','######..','######.#','##.###.#','######.#','######..','.####...','........'],
  coaster:          ['........','........','.######.','########','########','.######.','........','........'],
  // Twice-baked stack: two offset horizontal bars. Was a thick bottom-left to
  // top-right diagonal, which made it an unreadable duplicate of `stirrer` —
  // and at 8x8 a thick diagonal shaft reads as anything but a biscuit. Nothing
  // else in the set is a stack of horizontal bars, so this is unambiguous at
  // the 32px the Loot Bag actually renders.
  biscotti:         ['........','.#####..','.#####..','........','..#####.','..#####.','........','........'],
  crema:            ['..####..','.######.','########','##.##.##','########','.######.','..####..','........'],
  kettle:           ['..###...','.#####.#','#######.','#######.','#######.','.#####..','..###...','........'],
  // Paddle head on a thin diagonal shaft. The bare diagonal was hard to tell
  // from `diamond_stirrer`; giving this one a flat head and that one a spike
  // separates them at both ends rather than by thickness alone.
  stirrer:          ['....###.','....###.','.....#..','....#...','...#....','..#.....','.#......','#.......'],
  keepcup:          ['.######.','.#....#.','########','########','.######.','.######.','..####..','........'],
  tamper:           ['...##...','...##...','...##...','..####..','.######.','########','########','........'],
  glitch_latte:     ['##..##..','..##..##','##..##..','..##..##','##..##..','..##..##','##..##..','........'],
  cartridge:        ['.######.','.#....#.','.#.##.#.','.#.##.#.','.#....#.','.######.','.#....#.','.######.'],
  grinder:          ['..####..','.######.','..####..','...##...','..####..','.######.','########','........'],
  gold_portafilter: ['........','.######.','.######.','..####..','...##...','...#####','...#....','........'],
  mystery_cup:      ['.#####..','.#...#.#','...##..#','...#...#','.......#','...#....','.#####..','........'],
  diamond_stirrer:  ['...##...','..####..','.######.','..####..','...##...','...##...','...##...','...##...'],
  founders_bean:    ['..####..','.######.','##.#####','###.####','####.###','#####.##','.######.','..####..'],
  konami_roast:     ['#..##..#','.######.','########','##.##.##','########','.#....#.','..####..','........'],
};

export const COLLECTIBLE_SPRITE_IDS = Object.keys(MAPS);

export function CollectibleSprite({ icon, className = '' }: { icon: string; className?: string }) {
  if (icon.startsWith('https://')) {
    return (
      <img
        src={icon}
        alt="collectible"
        className={className}
        style={{ imageRendering: 'pixelated' }}
      />
    );
  }
  const map = MAPS[icon];
  if (!map) return null;
  const cells: JSX.Element[] = [];
  map.forEach((row, y) => {
    for (let x = 0; x < row.length; x++) {
      if (row[x] === '#') cells.push(<rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} />);
    }
  });
  return (
    <svg role="img" aria-label={icon} viewBox="0 0 8 8" className={className}
      fill="currentColor" shapeRendering="crispEdges">
      {cells}
    </svg>
  );
}
